import { SearchContextType } from "../search/search-context";

const getOptionalSearchValues = (formData: SearchContextType): string[] => {
  return formData?.optionalSearchValues
    ? formData.optionalSearchValues
        .map((key) => formData[key as keyof SearchContextType])
        .filter(
          (value): value is string =>
            typeof value === "string" && value.trim() !== "",
        )
    : [];
};
export default getOptionalSearchValues;
